<template>
  <div class="app-main-content city">
    <div class="grid-view">
      <div class="main-content">
        <div class="operations">
          <div class="triggers">
            <div>
              <el-form
                :inline="true"
                label-width="50px"
                label-position="left"
                @submit.native.prevent="filter.pageNum=1;toQuery()"
              >
                <el-form-item :label="$t('common.btn.query')">
                  <el-input
                    v-model="filter.likeName"
                    :placeholder="$t('common.tips.fuzzySearch')"
                    style="width:310px"
                  />
                </el-form-item>
                <el-button type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
                <el-button type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
                <el-button type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
                <el-button type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
              </el-form>
            </div>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="101201"
            :grid-params.sync="girdParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="total>0"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div v-if="editDialog.visible" class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item :label="$t('baseInfo.city.code')" required>
            <el-input v-model="editDialog.form.code" :disabled="tenantId!==PLATFORM_TENANT_ID" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.city.chineseName')">
            <el-input v-model="editDialog.form.chineseName" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.city.englishName')" required>
            <el-input v-model="editDialog.form.englishName" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.city.locationCode')">
            <el-input v-model="editDialog.form.locationCode" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CountryRegion')" required>
            <cargo-advance-select
              v-show="tenantId===PLATFORM_TENANT_ID"
              :select-type="selectTypeNames.basic_data_Country"
              :cache="false"
              filterable
              :callback-params="{key:'countryCode'}"
              callback-method-type="value"
              :default-value="editDialog.form.countryCode"
              :static-options="countryList"
              style="width:310px;"
              @parentCallBack="selectCargoItem"
            />
            <el-input
              v-show="tenantId!==PLATFORM_TENANT_ID"
              v-model="editDialog.form.countryName"
              :disabled="true"
              style="width:310px;"
            />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.city.lon')">
            <el-input v-model="editDialog.form.lon" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.city.lat')">
            <el-input v-model="editDialog.form.lat" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增弹窗（非平台维护） -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="platformDialog.visible"
      :title="$t('baseInfo.city.addBaseCity')"
      width="950px"
      :close-on-click-modal="false"
    >
      <base-city :window="true" />
      <span slot="footer">
        <el-button type="primary" @click="addFromPlatform">{{ $t('CargoMsg.Cargo_add') }}</el-button>
        <el-button @click="platformDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
// import pinyin from 'js-pinyin'
import baseCity from './components/baseCity'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getUserInfo } from '@/utils/auth'
import { getCountryList } from '@/api/country'
import { getLocationList, getLocationsByPlatform, saveLocation, saveLocations, addLocationByPlatform, delLocation } from '@/api/location'
import { getLoading } from '@/utils/utilBaseElement'
import { exportExcel } from '@/utils/tableDataExportUtils'

export default {
  name: 'City',
  components: { cargoAdvanceSelect, baseCity },
  data() {
    return {
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      selectTypeNames: TYPE_NAMES,
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        suppressContextMenu: false,
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport'),
              action: function() {
                self.exportExcelHandler()
              }
            }
          ]
        }
      },
      columnDefs: [
        {
          headerName: this.$t('baseInfo.city.code'),
          field: 'code',
          width: 100
        }, {
          headerName: this.$t('baseInfo.city.chineseName'),
          field: 'chineseName',
          width: 200
        }, {
          headerName: this.$t('baseInfo.city.englishName'),
          field: 'englishName',
          width: 200
        }, {
          headerName: this.$t('baseInfo.city.locationCode'),
          field: 'locationCode',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CountryRegion'),
          field: 'countryName',
          width: 200
        }, {
          headerName: this.$t('baseInfo.city.lon'),
          field: 'lon',
          width: 200
        }, {
          headerName: this.$t('baseInfo.city.lat'),
          field: 'lat',
          width: 200
        }
      ],
      rowData: [],
      countryList: [],
      tenantId: '',
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          code: '',
          chineseName: '',
          englishName: '',
          locationCode: '',
          countryCode: '',
          countryName: '',
          lon: '',
          lat: ''
        }
      },
      platformDialog: {
        visible: false
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  beforeCreate() {
    const self = this
    getCountryList().then(res => {
      self.countryList = res.data
      self.configCountryLang(self.countryList)
      self.toQuery()
      document.countryList = self.countryList
    })
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
  },
  beforeDestroy() {
    document.countryList = undefined
  },
  methods: {
    configCountryLang(countryList) {
      if (countryList.length === 0) {
        return
      }
      for (const item of countryList) {
        item.countryName = this.$i18n.locale === 'zh' ? item.chineseName : item.name
      }
    },
    toQuery() {
      const self = this
      let queryFunc = getLocationList
      if (self.tenantId === self.PLATFORM_TENANT_ID) {
        queryFunc = getLocationsByPlatform
      }
      const loading = getLoading()
      queryFunc(self.filter).then(res => {
        self.bindCountryName(res.data.list)
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
          self.rowData = res.data.list
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    bindCountryName(data) {
      if (!this.countryList || this.countryList.length === 0 || data.length === 0) {
        return
      }
      if (data[0].countryName) {
        return
      }
      const map = new Map()
      for (const item of this.countryList) {
        map.set(item.code, item.countryName)
      }
      for (const item of data) {
        item.countryName = map.get(item.countryCode)
      }
    },
    showEditDialog(isNew) {
      if (isNew) {
        if (this.tenantId !== this.PLATFORM_TENANT_ID) {
          this.showPlatform()
          return
        }
        this.editDialog.form = {
          uuid: '',
          code: '',
          chineseName: '',
          englishName: '',
          locationCode: '',
          countryCode: '',
          countryName: '',
          lon: '',
          lat: ''
        }
        this.filterCountryList = this.countryList
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const nodes = this.gridApi.rowModel.rowsToDisplay
        const cell = this.gridApi.getFocusedCell()
        const row = cell && nodes[cell.rowIndex] ? nodes[cell.rowIndex].data : null
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = row
        this.filterCountryList = this.countryList.filter(p => p.code === row.countryCode)
        if (this.filterCountryList.length > 0) {
          this.editDialog.form.countryName = this.filterCountryList[0].countryName
        }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    selectCargoItem(item) {
      this.editDialog.form[item.key] = item.value
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.code) {
        self.$message.warning(self.$t('baseInfo.city.codeCheck'))
        return
      }
      if (!form.englishName) {
        self.$message.warning(self.$t('baseInfo.city.englishNameCheck'))
        return
      }
      if (!form.countryCode) {
        self.$message.warning(self.$t('baseInfo.city.countryCheck'))
        return
      }
      let saveFunc = saveLocation
      if (!form.uuid && self.tenantId === self.PLATFORM_TENANT_ID) {
        saveFunc = addLocationByPlatform
      }
      saveFunc(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      })
    },
    remove() {
      const self = this
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.rowData[cell.rowIndex] : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        delLocation(row.uuid).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    },
    showPlatform() {
      if (document.resetBaseCity) {
        document.resetBaseCity()
      } else {
        setTimeout(() => {
          document.resetBaseCity()
        })
      }
      this.platformDialog.visible = true
    },
    addFromPlatform() {
      const self = this
      const rows = document.getSelectedBaseCityRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('CargoMsg.Cargo_CityNotSelected'))
        return
      }
      const form = []
      for (let i = 0; i < rows.length; ++i) {
        const item = rows[i]
        form.push({
          code: item.code,
          chineseName: item.chineseName,
          englishName: item.englishName,
          locationCode: item.locationCode,
          countryCode: item.countryCode,
          lon: item.lon,
          lat: item.lat
        })
      }
      saveLocations(form).then(res => {
        self.filter.pageNum = 1
        self.toQuery()
        self.platformDialog.visible = false
        self.$message.success(this.$t('Information.AddedSuccessfully'))
      }).catch(() => {
        self.platformDialog.visible = false
      })
    },
    exportExcelHandler() {
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel(this.$t('Information.City'), this.rowData, columnDefs)
    }
  }
}
</script>

<style lang="scss">
#app {
  .city .app-main-page {
    height: calc(100vh - 100px);
  }
  .hasTagsView {
    .city .app-main-page {
      height: calc(100vh - 130px);
    }
  }
}
</style>
